module.exports = __webpack_public_path__ + "img/top-up-popup.c9ec28e.png";